import type { TaskListItem } from "../../../api/requests";

export const sortMainTaskList = (items: TaskListItem[]): TaskListItem[] => {
  return [...items].sort((a, b) => {
    const aIsNew = a.status === "new";
    const bIsNew = b.status === "new";
    if (aIsNew !== bIsNew) return aIsNew ? -1 : 1;
    const aStart = new Date(a.startDateTime).getTime();
    const bStart = new Date(b.startDateTime).getTime();
    return bStart - aStart;
  });
};

export const sortTaskListByDirection = (
  items: TaskListItem[],
  direction: "asc" | "desc"
): TaskListItem[] => {
  return [...items].sort((a, b) => {
    const aStart = new Date(a.startDateTime).getTime();
    const bStart = new Date(b.startDateTime).getTime();
    return direction === "desc" ? bStart - aStart : aStart - bStart;
  });
};

export const mergeTaskListItems = (
  existing: TaskListItem[],
  incoming: TaskListItem[]
): TaskListItem[] => {
  const seen = new Set(existing.map((task) => task.id));
  const merged = [...existing];
  incoming.forEach((task) => {
    if (!seen.has(task.id)) merged.push(task);
  });
  return merged;
};
